import React from "react";
import { connect } from "react-redux";

import Barcode from "./Barcode";
import Set from "./Set";
import SelectGrade from "./SelectGrade";
import SelectLanguage from "./SelectLanguage";
import SelectCardRarity from "./SelectCardRarity";
import { inventoryActions } from "../../../redux/actions";
import { Col, Row } from "react-bootstrap";
import Quantity from "./Quantity";
import SerialNumber from "./SerialNumber";
import Rarity from "./Rarity";

const AddEditInventoryModalProductProperties = (props) => {
  const {
    values = {},
    currentStore,
    tradeinMargin,
    markupPresets,
    setFieldValue = () => {},
    setIsFirstRender = () => {},
    raritiesComponent = null,
    serialNumberComponent = null,
    setPriceChartingProductInfo,
    setPriceChartingProductInfoComponent,
    priceChartingProductInfoComponent = {},
    priceChartingProductInfo = { productMetaData: {} },
    conditionComponent = {
      component: <></>,
      productCondition: {},
      setConditionList: () => {},
      setProductCondition: () => {},
    },
  } = props;

  return (
    <>
      <Row className="mb-2">
        <Col
          md={12}
          className="px-3 d-flex gap-3 justify-content-start align-items-start"
        >
          <SelectGrade
            value={values.grade}
            setFieldValue={setFieldValue}
            setIsFirstRender={setIsFirstRender}
            conditionComponent={conditionComponent}
            priceChartingProductInfo={priceChartingProductInfo}
            setPriceChartingProductInfo={setPriceChartingProductInfo}
            setPriceChartingProductInfoComponent={
              setPriceChartingProductInfoComponent
            }
          />
          {/* condition */}
          {conditionComponent.component}
          <SelectLanguage
            value={values.language}
            setFieldValue={setFieldValue}
            priceChartingProductInfo={priceChartingProductInfo}
            setPriceChartingProductInfo={setPriceChartingProductInfo}
            setPriceChartingProductInfoComponent={
              setPriceChartingProductInfoComponent
            }
          />
          {/* Rarities */}
          <SelectCardRarity
            value={values.cardRarity}
            setFieldValue={setFieldValue}
            tradeinMargin={tradeinMargin}
            markupPresets={markupPresets}
            raritiesComponent={raritiesComponent}
            priceChartingProductInfo={priceChartingProductInfo}
            setPriceChartingProductInfo={setPriceChartingProductInfo}
            priceChartingProductInfoComponent={
              priceChartingProductInfoComponent
            }
            setPriceChartingProductInfoComponent={
              setPriceChartingProductInfoComponent
            }
          />
        </Col>
      </Row>
      <Row>
        <Col
          md={10}
          className="d-flex gap-3 justify-content-start align-items-end"
        >
          <Set
            value={values.set}
            setFieldValue={setFieldValue}
            priceChartingProductInfo={priceChartingProductInfo}
          />
          <Rarity
            value={values.rarity}
            setFieldValue={setFieldValue}
            priceChartingProductInfo={priceChartingProductInfo}
          />
          <Barcode
            value={values.barcode}
            setFieldValue={setFieldValue}
            priceChartingProductInfo={priceChartingProductInfo}
          />
          {/* Serial Number */}
          <SerialNumber
            priceChartingProductInfo={priceChartingProductInfo}
            handleChange={() => {
              if (
                values?.serialNumber &&
                (values.quantity > 1 || values.onlineQuantity > 1)
              ) {
                setFieldValue("quantity", 1);
                setFieldValue("onlineQuantity", 1);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
  tradeinMargin: state.tradeDiscount.tradeinMargin,
  markupPresets: state.tradeDiscount.markupPresets,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddEditInventoryModalProductProperties);
